import Promise from 'bluebird';
import { getCldrLocale } from '@bingads-webui/i18n-model-setup';
import { I18nModel } from '@bingads-webui-universal/i18n-model';

const cldrContext = require.context(
  '@bingads-webui-universal/i18n-cldr-data-modern/locales-simplified',
  false,
  /\.json$/
);

export const i18nDummy = new I18nModel({
  name: 'dummy',
  failFast: true,
  loadCLDRData: (locale) => {
    const cldrLocale = getCldrLocale(locale);
    const modulePath = `./${cldrLocale}.json`;
    return Promise.resolve(cldrContext(modulePath))
      .then(data => I18nModel.loadCLDRData(data))
      .then(() => cldrLocale);
  },
  loadTranslationData: () => ({}),
});
